import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    update(e) {
        let state = e.target.getAttribute('data-state');
        
        if (e.way == 'enter'){
            this.setStyle(state);
        }
    }

    setStyle(style){
        this.el.setAttribute('data-style', style);
    }
}
